import { render } from "./Tip.vue?vue&type=template&id=7d202446"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__